import { render } from "./side-nav-outer-toolbar.vue?vue&type=template&id=26143cce"
import script from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=26143cce&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__